import { render } from "./NewOtherCompanyCustomer.vue?vue&type=template&id=710f6520"
import script from "./NewOtherCompanyCustomer.vue?vue&type=script&lang=js"
export * from "./NewOtherCompanyCustomer.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__